var map = {
	"./industries/REP.png": 497,
	"./industries/bfsi.png": 498,
	"./industries/ecomm.png": 499,
	"./industries/el.png": 500,
	"./industries/evnt.png": 501,
	"./industries/fnb.png": 502,
	"./industries/gaming.png": 503,
	"./industries/health.png": 504,
	"./industries/media.png": 505,
	"./industries/real-estate.jpg": 506,
	"./industries/sn.png": 507,
	"./industries/th.png": 508,
	"./industries/trans.png": 509,
	"./solution/ai.png": 329,
	"./solution/app.png": 330,
	"./solution/ar.png": 331,
	"./solution/augmented-reality-hololens.png": 332,
	"./solution/blockchain.jpg": 333,
	"./solution/d1.png": 334,
	"./solution/d10.png": 335,
	"./solution/d11.png": 336,
	"./solution/d2.png": 337,
	"./solution/d3.png": 338,
	"./solution/d4.png": 339,
	"./solution/d5.png": 340,
	"./solution/d6.png": 341,
	"./solution/d7.png": 342,
	"./solution/d8.png": 343,
	"./solution/d9.png": 344,
	"./solution/logos/4glte.png": 50,
	"./solution/logos/Autoit.png": 51,
	"./solution/logos/Java_ee7.png": 52,
	"./solution/logos/Opencart.png": 53,
	"./solution/logos/Volley.png": 54,
	"./solution/logos/Zeplin.png": 55,
	"./solution/logos/ajax.png": 56,
	"./solution/logos/amqp.png": 57,
	"./solution/logos/android-launcher.png": 58,
	"./solution/logos/android-tv.png": 59,
	"./solution/logos/android.png": 60,
	"./solution/logos/android1.png": 61,
	"./solution/logos/android_gear.png": 62,
	"./solution/logos/android_gradle.png": 63,
	"./solution/logos/android_nougat.png": 64,
	"./solution/logos/android_studio.png": 65,
	"./solution/logos/androidview_animations.png": 66,
	"./solution/logos/anfetworking.png": 67,
	"./solution/logos/angularjs.png": 68,
	"./solution/logos/anndroid_wear.png": 69,
	"./solution/logos/api_development.png": 70,
	"./solution/logos/apple-3d-touch.png": 71,
	"./solution/logos/apple-callkit.png": 72,
	"./solution/logos/apple-healthkit.png": 73,
	"./solution/logos/apple-watch.png": 74,
	"./solution/logos/apple-watch1.png": 75,
	"./solution/logos/apple.jpg": 76,
	"./solution/logos/apple.png": 77,
	"./solution/logos/appletv.png": 78,
	"./solution/logos/aspnet.png": 79,
	"./solution/logos/augmented_reality.png": 80,
	"./solution/logos/aws.png": 81,
	"./solution/logos/bl_deviceintegration.png": 82,
	"./solution/logos/bluetooth.png": 83,
	"./solution/logos/bootstrap.png": 84,
	"./solution/logos/bugzilla.png": 85,
	"./solution/logos/c-sharp.png": 86,
	"./solution/logos/cake-php.png": 87,
	"./solution/logos/cloudsync.png": 88,
	"./solution/logos/cms_solution_integration.png": 89,
	"./solution/logos/coap.png": 90,
	"./solution/logos/cocoa-touch.png": 91,
	"./solution/logos/cocoapods.png": 92,
	"./solution/logos/codeigniter.png": 93,
	"./solution/logos/comprehensive_order_management.png": 94,
	"./solution/logos/conversion_optimization.png": 95,
	"./solution/logos/core_data.png": 96,
	"./solution/logos/coreldrow.png": 97,
	"./solution/logos/css.png": 98,
	"./solution/logos/custom_page_development.png": 99,
	"./solution/logos/customized_eCommerce-_site_development.png": 100,
	"./solution/logos/dagger2.png": 101,
	"./solution/logos/desired_payment_gateway_options.png": 102,
	"./solution/logos/dot_net_core.png": 103,
	"./solution/logos/dot_net_yet.png": 104,
	"./solution/logos/dreamweaver.png": 105,
	"./solution/logos/drupal.png": 106,
	"./solution/logos/eclipse.png": 107,
	"./solution/logos/ember.png": 108,
	"./solution/logos/ethernet.png": 109,
	"./solution/logos/extensionp_plugin_integration (1).png": 110,
	"./solution/logos/extensionp_plugin_integration.png": 111,
	"./solution/logos/fitbit.png": 112,
	"./solution/logos/fitness_tracker.png": 113,
	"./solution/logos/flutter.png": 114,
	"./solution/logos/foundation.png": 115,
	"./solution/logos/git.png": 116,
	"./solution/logos/glide.png": 117,
	"./solution/logos/google_glassiWatch.png": 118,
	"./solution/logos/gps_watch.png": 119,
	"./solution/logos/gridsystems.png": 120,
	"./solution/logos/gsm_network.png": 121,
	"./solution/logos/hibernate5.2.5.png": 122,
	"./solution/logos/html-5.png": 123,
	"./solution/logos/html.png": 124,
	"./solution/logos/html5_boilerplarte.png": 125,
	"./solution/logos/iMessage.png": 126,
	"./solution/logos/ibeacon-device.png": 127,
	"./solution/logos/illustrator.png": 128,
	"./solution/logos/in-app-purchase.png": 129,
	"./solution/logos/in_app_purchases.png": 130,
	"./solution/logos/indesign.png": 131,
	"./solution/logos/intelliJ.png": 132,
	"./solution/logos/ionic.png": 133,
	"./solution/logos/ios.png": 134,
	"./solution/logos/jQuery.png": 135,
	"./solution/logos/java.png": 136,
	"./solution/logos/jdbc.png": 137,
	"./solution/logos/jenkins.png": 138,
	"./solution/logos/jira.png": 139,
	"./solution/logos/jmeter.png": 140,
	"./solution/logos/joomla.png": 141,
	"./solution/logos/jquerymobile.png": 142,
	"./solution/logos/js.png": 143,
	"./solution/logos/json.png": 144,
	"./solution/logos/kendo.png": 145,
	"./solution/logos/laravel.png": 146,
	"./solution/logos/less.png": 147,
	"./solution/logos/magento-logo1.png": 148,
	"./solution/logos/magento-logo10.png": 149,
	"./solution/logos/magento-logo11.png": 150,
	"./solution/logos/magento-logo2.png": 151,
	"./solution/logos/magento-logo3.png": 152,
	"./solution/logos/magento-logo4.png": 153,
	"./solution/logos/magento-logo5.png": 154,
	"./solution/logos/magento-logo6.png": 155,
	"./solution/logos/magento-logo7.png": 156,
	"./solution/logos/magento-logo8.png": 157,
	"./solution/logos/magento-logo9.png": 158,
	"./solution/logos/magento.png": 159,
	"./solution/logos/mantis.png": 160,
	"./solution/logos/material_design.png": 161,
	"./solution/logos/maven.png": 162,
	"./solution/logos/migration_to_shopify.png": 163,
	"./solution/logos/mobile_commerce.png": 164,
	"./solution/logos/mongo_db.png": 165,
	"./solution/logos/mqtt.png": 166,
	"./solution/logos/multi_store_multi_lingual_setup.png": 167,
	"./solution/logos/mvc_framework.png": 168,
	"./solution/logos/mysql.png": 169,
	"./solution/logos/mysql5x.png": 170,
	"./solution/logos/netbeans.png": 171,
	"./solution/logos/netframework4.5.png": 172,
	"./solution/logos/nodejs.png": 173,
	"./solution/logos/objective-c.png": 174,
	"./solution/logos/omni_channel_planning.png": 175,
	"./solution/logos/online_shopping_cart_management.png": 176,
	"./solution/logos/open_source.png": 177,
	"./solution/logos/opencart-module-integration.png": 178,
	"./solution/logos/opnecart_customized_template_design.png": 179,
	"./solution/logos/payment_gateway_integration.png": 180,
	"./solution/logos/personalizedstorefront.png": 181,
	"./solution/logos/phonegap.png": 182,
	"./solution/logos/photoshop.png": 183,
	"./solution/logos/php.png": 184,
	"./solution/logos/php4x.png": 185,
	"./solution/logos/php5x.png": 186,
	"./solution/logos/php7x.png": 187,
	"./solution/logos/powerful_store_management.png": 188,
	"./solution/logos/prototypejs.png": 189,
	"./solution/logos/push_notifications.png": 190,
	"./solution/logos/react_native.png": 191,
	"./solution/logos/realm.png": 192,
	"./solution/logos/rest.png": 193,
	"./solution/logos/retrofit2.png": 194,
	"./solution/logos/saas.png": 195,
	"./solution/logos/samsung_gear.png": 196,
	"./solution/logos/scalable_application.png": 197,
	"./solution/logos/selenium_forweb.png": 198,
	"./solution/logos/selenium_with_appium.png": 199,
	"./solution/logos/sencha_touch.png": 200,
	"./solution/logos/sensors.png": 201,
	"./solution/logos/shoppify.png": 202,
	"./solution/logos/sirikit.png": 203,
	"./solution/logos/sketch.png": 204,
	"./solution/logos/soap.png": 205,
	"./solution/logos/spring.png": 206,
	"./solution/logos/sql_server2014.png": 207,
	"./solution/logos/sqlite.png": 208,
	"./solution/logos/swift.png": 209,
	"./solution/logos/symfony.png": 210,
	"./solution/logos/theme_customization.png": 211,
	"./solution/logos/third-party_integrations.png": 212,
	"./solution/logos/touchid.png": 213,
	"./solution/logos/visual_studio.png": 214,
	"./solution/logos/visual_studio_2015.png": 215,
	"./solution/logos/wcf.png": 216,
	"./solution/logos/web_stress.png": 217,
	"./solution/logos/wireless.png": 218,
	"./solution/logos/woocommerce_theme_customization.png": 219,
	"./solution/logos/wordPress.png": 220,
	"./solution/logos/xamarian.png": 221,
	"./solution/logos/xamarin_for_visual_studio.png": 222,
	"./solution/logos/xamarin_forms.png": 223,
	"./solution/logos/xamarin_test_cloud.png": 224,
	"./solution/logos/xcode.png": 225,
	"./solution/logos/xml.png": 226,
	"./solution/logos/xmpp.png": 227,
	"./solution/logos/yii.png": 228,
	"./solution/logos/zend.png": 229,
	"./solution/logos/zoho.png": 230,
	"./solution/ondemand.jpg": 345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;